var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.3108C12.5795 12.3108 13.86 11.0304 13.86 9.45082C13.86 7.87129 12.5795 6.59082 11 6.59082C9.42046 6.59082 8.14 7.87129 8.14 9.45082C8.14 11.0304 9.42046 12.3108 11 12.3108Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31833 7.78242C5.12417 -0.155913 16.885 -0.146746 18.6817 7.79159C19.7358 12.4483 16.8392 16.3899 14.3 18.8283C12.4575 20.6066 9.5425 20.6066 7.69083 18.8283C5.16083 16.3899 2.26417 12.4391 3.31833 7.78242Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locations-icon.96c253b8fbfff542a60b5db8412685a1.svg";
export { ForwardRef as ReactComponent };